import { useContext } from 'react'
import { useQuery, useQueryClient } from 'react-query'

import { AppContext } from '../../contexts'
import { useAuthSettings } from '../authorization'
import { useRawListingData } from '../listing'
import { fireAddressAndPricePrefetch } from '../queries'
import { useIsExtension } from '../utility'
import { getQueryDefaults, buildMikasaClient } from '../../helpers/api'

export const useBuyerSettingsQuery = () => {
  const queryClient = useQueryClient()
  const authSettings = useAuthSettings()
  const { clientType, setClientType, customerProfileId } =
    useContext(AppContext)
  const { address, listingPrice } = useRawListingData()
  const isExtension = useIsExtension()

  return useQuery(
    ['buyerSettings', authSettings?.scheme],
    () =>
      getBuyerSettings(authSettings, {
        customerProfileId: customerProfileId,
        isExtension,
      }),
    {
      ...getQueryDefaults(),
      staleTime: 0,
      enabled:
        Boolean(authSettings) && (isExtension || Boolean(customerProfileId)),
      onSuccess: data => {
        // TODO: move to auth layer over single endpoint check
        if (data?.clientType !== clientType) {
          setClientType(data?.clientType)

          queryClient.removeQueries({
            predicate: query => query.queryKey[0] !== 'buyerSettings',
          })

          if (address && listingPrice) {
            fireAddressAndPricePrefetch(
              queryClient,
              authSettings,
              address,
              listingPrice
            )
          }
        }
      },
    }
  )
}

const getBuyerSettings = async (
  authSettings,
  { customerProfileId, isExtension }
) => {
  const client = await buildMikasaClient(authSettings)

  let endpoint = 'chromebot/buyers'
  if (!isExtension) {
    // NOTE: customer_profile_id REQUIRED for non-extension mode or this will auth with bad data
    endpoint += `?${new URLSearchParams({
      customer_profile_id: customerProfileId,
    })}`
  }

  const response = await client.get(endpoint)

  return response?.data
}
